// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8edcd17d","455":"350b380e","977":"9e52a066"}[chunkId] + ".chunk.js";
};